import { BaseModel } from "../../Bases/BaseModel";
//import { UsuarioFiltroAcesso } from "./UsuarioFiltroAcesso";

export class Empresa extends BaseModel {
    constructor(
        public nome = '',
        public cnpj_cpf = '',
    ) {
        super();
    }
}

